import React from 'react';
import { useParams } from 'react-router-dom';

import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { RadarChart, PolarGrid, ResponsiveContainer, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, Tooltip } from 'recharts';

import Spinner from '../../../components/Spinner';
import ErrorBox from '../../../components/ErrorBox';
import NoData from '../../../components/NoData';

const formatter = value => `${value}%`;

const fetchPrimaryCategories = async ({ queryKey }) => {
  const [, locationId] = queryKey;
  
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}api/v4/locachecker/primaryInsights`, {
    params: { locationId },
  });
  
  return data.data;
};

const renderContent = (primaryCategories, isLoading, isError) => {
  if (isLoading) {
    return <Spinner height={450}/>;
  }
  
  if (isError) {
    return <ErrorBox description="We encountered an issue loading your Primary Categories data. Please try again."/>;
  }
  
  if (primaryCategories.length === 0) {
    return <NoData description={'No data to display for Primary Categories'}/>
  }
  
  return <ResponsiveContainer width="100%" height={500}>
    <RadarChart outerRadius={200} data={primaryCategories}>
      <PolarGrid/>
      <PolarAngleAxis dataKey="subject"/>
      <PolarRadiusAxis tickFormatter={formatter} angle={75} domain={[0, 100]}/>
      <Radar name="Positive" dataKey="pos" stroke="#7ec95a" fill="#bfeccf" fillOpacity={0.6} isAnimationActive={true}/>
      <Radar name="Negative" dataKey="neg" stroke="#e25c44" fill="#fccccc" fillOpacity={0.6} isAnimationActive={true}/>
      <Legend verticalAlign="top" height={50} align="right"/>
      <Tooltip formatter={formatter}/>
    </RadarChart>
  </ResponsiveContainer>
}

const PrimaryInsights = () => {
  const { locationId } = useParams();
  
  const {
    data: primaryCategories,
    isLoading,
    isError
  } = useQuery({
    queryKey: ['primaryCategories', locationId],
    queryFn: fetchPrimaryCategories,
    enabled: !!locationId,
  });
  
  return (
    <div
      className="flex-1 w-1/2 h-auto min-h-[450px] [&>svg]:!overflow-visible rounded-md bg-white p-8 px-10 shadow-[0px_4px_8px_0px_#0000000D]">
      <div className="border-b-2 border-gray-500 ">
        <h3>Primary Categories</h3>
      </div>
      
      <div className="relative flex w-full py-5 px-0 h-[500px] min-h-[500px] text-xs">
        {renderContent(primaryCategories, isLoading, isError)}
      </div>
    </div>
  );
};

export default PrimaryInsights;
